import moment from "moment"

/* Hour offsets shown in the picker: UTC-11 … UTC+12 */
export const OFFSETS = Array.from({ length: 24 }, (_, i) => i - 11)

/* Whole-hour offset of the user's device, e.g. +5 */
export const deviceOffsetHours = () => Math.round(-new Date().getTimezoneOffset() / 60)

/* Currently selected offset in hours (from cache, fallback to device) */
export const currentOffsetHours = () => {
    const stored = localStorage.getItem("timezone")
    return stored !== null && stored !== "" ? parseInt(stored, 10) : deviceOffsetHours()
}

/* "+05:00" / "-03:00" / "+00:00" — format for SQL CONVERT_TZ */
export const formatOffset = (hours) => {
    const sign = hours < 0 ? "-" : "+"
    return `${sign}${String(Math.abs(hours)).padStart(2, "0")}:00`
}

/* Offset string of the current selection for API requests */
export const apiOffset = () => formatOffset(currentOffsetHours())

/* "UTC" / "UTC +5" / "UTC -3" */
export const offsetLabel = (hours) => {
    if (hours === 0) return "UTC"
    return `UTC ${hours > 0 ? "+" : "-"}${Math.abs(hours)}`
}

/* Compact label for the minimized sidebar: "UTC" / "+5" / "-3" */
export const offsetShort = (hours) => {
    if (hours === 0) return "UTC"
    return `${hours > 0 ? "+" : "-"}${Math.abs(hours)}`
}

/* Current wall-clock time in the given offset, "HH:mm" */
export const timeAt = (hours) => moment().utcOffset(hours * 60).format("HH:mm")
